import React from 'react'
import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import { Toast, Modal, WhiteSpace } from 'antd-mobile'
import { Button } from 'components'
import keyMirror from 'pkeymirror'
import { intl } from 'utils'
import messages from './messages'

// ------------------------------------
// Constants
// ------------------------------------
export const BANK_CARD_ADD_SESSION_BANK_CARD = keyMirror({
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
}, 'BANK_CARD_ADD_SESSION_BANK_CARD')

// ------------------------------------
// Actions
// ------------------------------------
var alertInstance
export function submit(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          ...data,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          userAgent: navigator.userAgent,
        },
        endpoint: 'cgs/personal/card/advance',
        requestAction: BANK_CARD_ADD_SESSION_BANK_CARD.SUBMIT_REQUEST,
        successAction: BANK_CARD_ADD_SESSION_BANK_CARD.SUBMIT_SUCCESS,
        success: function(result) {
          if (!result.payUrl) {
            return Toast.info(
              'Bank validate url get failed, please try again later!'
            )
          }
          Toast.hide()
          alertInstance = Modal.alert(
            '',
            <div className='text-center' style={{ position: 'relative' }}>
              <span
                className='iconfont iconState-Wait'
                style={{ fontSize: '40px' }}
              />
              <WhiteSpace size='xs' />
              <p className='font-sm'>
                <b>{intl.formatMessage(messages.processing)}</b>
              </p>
              <p
                className='font-xs gray'
                dangerouslySetInnerHTML={{
                  __html: intl.formatHTMLMessage(messages.description),
                }}
              />
              <WhiteSpace size='lg' />
              <Button
                type='primary'
                name='custom'
                inline
                className='am-button-xs'
                onClick={() => {
                  document.open()
                  document.write(result.payUrl)
                  document.close()
                }}
              >
                {intl.formatMessage(messages.ok)}
              </Button>
            </div>,
            []
          )
        },
        error: function(result) {
          setTimeout(() => {
            Toast.hide()
          }, 1500)
        },
      })
    )
  }
}

export function closeModal() {
  return (dispatch) => {
    alertInstance && alertInstance.close()
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BANK_CARD_ADD_SESSION_BANK_CARD.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_SESSION_BANK_CARD.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'bankCardAddSessionBankCard',
    reducerMap: {
      bankCardAddSessionBankCardState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
